import {useCallback} from 'react';
import {shallowEqual, useSelector, useStore} from 'react-redux';
import {selectIsPremium} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {selectGiftingData} from '~/CreateFabricInvitation/reducers/giftingOptions/selectors';
import {UPDATE_GIFT_OPTIONS} from '~/common/fabric/reducers/giftingOptions/constants';
import {selectEvent} from '~/common/gift-keywords/utils';
import {eviteVendors, getDiscDisplayText, getWalmartURL} from '~/common/vendors/vendors';
import {VendorDisc} from '~/ViewInvitation/common/VendorDisc';
import {Typography} from '~library/atoms/Typography';
import {GiftEditIcon} from '~library/svg/GiftEditIcon';
import {OptionWrapper} from './OptionWrapper';

import './GiftIdeas.sass';

// TODO: Combine the following components and have a single sass file:
// - ViewInvitation/routes/Landing/GiftingModule/GiftingModule.sass
// - InvitationMaker/OneStepCreatePage/components/Options/components/GiftIdeas.js
export const GiftIdeas = ({
  shouldShowUpsellModal,
  setToToggleOff,
  setToToggleOn,
  toggleUpsellModal,
}) => {
  const store = useStore();
  const eviteEvent = useSelector((state) => state.eviteEvent);
  const event = useSelector(selectEvent);
  const isPremium = useSelector(selectIsPremium);
  const giftingOptions = useSelector(({giftingOptions: options}) => options);
  const showGifting = useSelector(
    ({giftingOptions: options}) => options.options?.event_option_show_gifting
  );
  const giftingData = useSelector(selectGiftingData, shallowEqual);
  const displayText = getDiscDisplayText(eviteEvent);
  const walmartURL = getWalmartURL(event);
  const walmartVendor = eviteVendors.find(({name}) => name === 'Walmart');

  const onEdit = useCallback(() => {
    setToToggleOn('giftIdeas');
    store.dispatch({
      type: UPDATE_GIFT_OPTIONS,
      payload: {
        showGifting: true,
        options: {
          ...giftingOptions.options,
          // biome-ignore lint/style/useNamingConvention: existing error
          event_option_show_gifting: true,
        },
      },
    });
  }, [giftingOptions.options, setToToggleOn, store]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const removeAction = useCallback(() => {
    store.dispatch({
      type: UPDATE_GIFT_OPTIONS,
      payload: {
        showGifting: false,
        options: {
          ...giftingOptions.options,
          // biome-ignore lint/style/useNamingConvention: existing error
          event_option_show_gifting: false,
        },
      },
    });
  }, [store]);

  const onRemove = useCallback(async () => {
    if (shouldShowUpsellModal()) {
      setToToggleOff('giftIdeas');
      toggleUpsellModal();
    } else {
      removeAction();
    }
  }, [removeAction, setToToggleOff, shouldShowUpsellModal, toggleUpsellModal]);

  return (
    <OptionWrapper
      icon={<GiftEditIcon />}
      title="Gift ideas"
      subtitle={
        <>
          Include Evite&apos;s top gift suggestions from Amazon and Walmart.
          {!isPremium && (
            <>
              <br />
              <Typography as="span" variant="list2" color="roseWebText">
                Switch to Premium
              </Typography>{' '}
              to remove these gift ideas.
            </>
          )}
        </>
      }
      isActive={showGifting}
      onEdit={onEdit}
      onRemove={onRemove}
      hideEdit
      showDiamond={!isPremium}
      noChildrenDefaultStyle
    >
      <div
        className="view-invitation__gifting-module__vendor-list gift-ideas__vendor-list"
        data-qa-id="gifting-vendor-list"
      >
        <VendorDisc
          registry={giftingData}
          dataQaId={`af-invite-disc-${giftingData.vendorName.toLowerCase().replace(' ', '-')}`}
          displayText={displayText}
        />
        <VendorDisc
          registry={{
            ...walmartVendor,
            // biome-ignore lint/style/useNamingConvention: existing error
            vendor_name: walmartVendor.name,
            url: walmartURL,
          }}
          dataQaId="af-invite-disc-walmart"
          displayText={displayText}
        />
      </div>
    </OptionWrapper>
  );
};
